<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="礼包名称" name="name"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button color="sys" icon="add" power="b_gift_package_info_edit" @click="navigateTo('/gift_package_add')">新增礼包</c-button>
            </m-operate>

            <c-table ref="table" code="user_level_list">

                <c-table-column
                        label="礼包名称"
                        name="name"
                        width="200"
                >
                </c-table-column>

                <c-table-column
                        label="礼包价值(元)"
                        name="total_price"
                        width="200"
                >
                    <template v-slot="{data}">
                        {{'¥'+data.total_price.toFixed(2)}}
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                >
                    <template v-slot="row">
						<c-table-button power="b_gift_package_info_view" @click="navigateTo(`/gift_package_detail/${row.data.id}`)" >查看</c-table-button>
                        <c-table-button power="b_gift_package_info_edit" @click="navigateTo(`/gift_package_edit/${row.data.id}`)" >编辑</c-table-button>
                        <c-table-button power="b_gift_package_info_edit" @click="deleteInfo(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_gift_package_info',

        data() {
            return {
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('giftPackageList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {

            searchHandle(data) {
                this.$refs.table.load({
                    url: '/gift_package/list',
                    data
                });
            },
            deleteInfo(item) {
                this.$confirm({
                    text: '确定要删除此礼包吗？',
                    resolve: () => {
                        this.request({
                            url: '/gift_package/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },



        }
    }
</script>